import React, { useContext } from 'react';
import { WindowSizeContext } from '/src/App';

import './style.css';

const CTAButton = ({
    text,
    onClick,
    category
}) => {
    const { deviceType } = useContext(WindowSizeContext);

    return (
        <button className={`text-align-center cta-button ${category} ${deviceType}`} onClick={onClick}>
            {text}
        </button>
    );
};

export default CTAButton;
